import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import "./ln.scss";

// Parolni tiklash sahifalari (/forgotpassword, /createpassword) uchun umumiy ko'rinish:
// chapda izoh va qadamlar, o'ngda forma kartasi (login sahifasi bilan bir xil)
export default function ResetShell({ step, children }) {
  const { t } = useTranslation();
  const steps = [
    { title: t("Enter email"), text: t("ln_reset_step1_text") },
    { title: t("Create a password"), text: t("ln_reset_step2_text") },
  ];
  return (
    <div className="ln-login ln">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Vis Nefrit | {t("Forgot password")}</title>
      </Helmet>
      <div className="ln-login__inner">
        <div className="ln-login__info">
          <span className="ln-eyebrow">{t("ln_cabinet")}</span>
          <h1 className="ln-login__heading">{t("ln_reset_title")}</h1>
          <p className="ln-lead">{t("ln_reset_text")}</p>
          <ol className="ln-reset__steps">
            {steps.map((s, i) => (
              <li key={i} className={i < step ? "is-done" : i === step ? "is-active" : ""}>
                <span className="ln-reset__num">
                  {i < step ? (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10" /></svg>
                  ) : (
                    i + 1
                  )}
                </span>
                <div>
                  <strong>{s.title}</strong>
                  <p>{s.text}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>

        <div className="ln-login__card">
          <span className="ln-reset__badge">
            {t("ln_reset_step", { n: step + 1, total: steps.length })}
          </span>
          {children}
          <p className="ln-login__register">
            {t("ln_reset_remember")}{" "}
            <Link to="/login" className="ln-login__link">{t("Login")}</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

// Laravel xato javobidan maydon xatolari va ko'rsatiladigan matnlar
export function parseError(err) {
  const res = err.response;
  if (!res) return { errors: undefined, lines: [err.message] };
  const body = res.data;
  const errors = body?.errors || body?.data?.errors;
  const fieldMessages =
    errors && typeof errors === "object" ? Object.values(errors).flat().filter(Boolean) : [];
  const mainMessage =
    body?.error ||
    body?.message ||
    body?.data?.error ||
    body?.data?.message ||
    (typeof body === "string" ? body : "");
  const lines = fieldMessages.length
    ? fieldMessages
    : [mainMessage || `${res.status} ${res.statusText || ""}`.trim()];
  return { errors, lines, status: res.status };
}

export const firstMsg = (v) => [].concat(v || []).join(" ");
